const setSection = data => ({
  type: "SET_SECTION",
  data
});

export const mutation = {
  setSection
};
